import React from 'react';

import { OrdersListPage } from '@components/OrdersListPage';
import { ScreenContent } from '@components/ScreenContent';
import { useNewOrdersStore } from '@stores';
import { useTranslation } from '@providers/I18n';

export const NewOrdersScreen: React.FC = () => {
  const { t } = useTranslation();
  const { orders: newOrders, loading } = useNewOrdersStore();

  return (
    <ScreenContent>
      <OrdersListPage
        ordersList={newOrders}
        loading={loading}
        type="New"
        title={t('newOrders.header', 'Accepted orders')}
        noOrdersMessage={t('newOrders.noNewOrdersAtTheMoment', {
          defaultValue: 'No new orders at the moment',
        })}
        loadedAllOrdersMessage={t('newOrders.loadedAllOrdersMessage', {
          defaultValue: 'Loaded all ({{ordersCount}}) new orders',
          ordersCount: newOrders.length,
        })}
      />
    </ScreenContent>
  );
};
